export default
  debounce = (fn, interval) ->
    timer = undefined
    ->
      clearTimeout timer
      args = arguments
      that = this
      timer = setTimeout((->
        fn.apply that, args
        return
      ), interval)
      return